module.exports = __webpack_public_path__ + "static/media/room_image.ec772650.jpeg";